



































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RangeSlider from "@/components/VRangeSliderStyling.vue";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from "@/definitions";

import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    RangeSlider,
    ColorPicker,
    ValueEdit,
    DropdownList,
    ColorSelector,
    AdjustedBalloon,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class LineStyle extends Vue {
  @Prop()
  private layer!: LineLayer;

  //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
  //こいつはpropsでもらいたい
  openStatus = {
    opend: true
  };

  lineStyleContentsOpenAnimate = false;
  lineStyleContentsCloseAnimate = false;

  open() {
    if (this.openStatus.opend) {
      this.lineStyleContentsCloseAnimate = true;
      setTimeout(() => {
        this.lineStyleContentsCloseAnimate = false;
        this.lineStyleContentsOpenAnimate = false;
        this.openStatus.opend = false;
      }, 200);
    } else {
      this.openStatus.opend = true;
      this.lineStyleContentsOpenAnimate = true;
      setTimeout(() => {
        this.lineStyleContentsOpenAnimate = false;
      }, 250);
    }
  }
  //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

  //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
  //こいつはpropsでいらない
  isColorPickerVisible = false;
  showColorPicker() {
    this.isColorPickerVisible  = true;
  }
  closeColorPicker() {
    this.isColorPickerVisible  = false;
  }
  //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

  //↓↓↓↓↓線種セレクト表示非表示↓↓↓↓↓
  //こいつはpropsでいらない
  // ドロップダウンリスト
  isStrokeTypeDropdownActive = false;
  private get strokeTypeDropdownItems() {
    var items = new Array();
    items.push({ id: 0, isSelected: this.strokeType == 0, image: "line0" });
    items.push({ id: 1, isSelected: this.strokeType == 1, image: "line1" });
    items.push({ id: 2, isSelected: this.strokeType == 2, image: "line2" });
    items.push({ id: 3, isSelected: this.strokeType == 3, image: "line3" });
    items.push({ id: 4, isSelected: this.strokeType == 4, image: "line4" });
    return items;
  }
  //↑↑↑↑↑線種セレクト表示非表示↑↑↑↑↑

  //↓↓↓↓↓始点セレクト表示非表示↓↓↓↓↓
  //こいつはpropsでいらない
  isStartTypeDropdownActive = false;
  private get startTypeDropdownItems() {
    var items = new Array();
    items.push({ id: 0, isSelected: this.startType == 0, image: "line0" });
    items.push({ id: 1, isSelected: this.startType == 1, image: "start1" });
    items.push({ id: 2, isSelected: this.startType == 2, image: "start2" });
    items.push({ id: 3, isSelected: this.startType == 3, image: "start3" });
    items.push({ id: 4, isSelected: this.startType == 4, image: "start4" });
    items.push({ id: 5, isSelected: this.startType == 5, image: "start5" });
    return items;
  }
  //↑↑↑↑↑始点セレクト表示非表示↑↑↑↑↑

  //↓↓↓↓↓終点セレクト表示非表示↓↓↓↓↓
  //こいつはpropsでいらない
  isEndTypeDropdownActive = false;
  private get endTypeDropdownItems() {
    var items = new Array();
    items.push({ id: 0, isSelected: this.endType == 0, image: "line0" });
    items.push({ id: 1, isSelected: this.endType == 1, image: "end1" });
    items.push({ id: 2, isSelected: this.endType == 2, image: "end2" });
    items.push({ id: 3, isSelected: this.endType == 3, image: "end3" });
    items.push({ id: 4, isSelected: this.endType == 4, image: "end4" });
    items.push({ id: 5, isSelected: this.endType == 5, image: "end5" });
    return items;
  }
  //↑↑↑↑↑終点セレクト表示非表示↑↑↑↑↑

  //↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓こっから具体的な処理↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓

  private fixNumber(value: number, delta: number = 0): number {
    // X.XX に補正
    var fixed = Math.round(value * 100) / 100 + delta;
    // 0 ~ 10mm
    // if(fixed < 0) { fixed = 0; }
    // if(fixed > 10) { fixed = 10; }
    return fixed;
  }

  private setType(value: number, propertyName: string) {

    //閉じる(なぜか閉じてくれない)
    this.isStrokeTypeDropdownActive = false;
    this.isStartTypeDropdownActive = false;
    this.isEndTypeDropdownActive = false;

    this.changeLayerProperty(value, propertyName);
  }

  private setNumber(value: number, propertyName: string) {
    // 値の補正
    var fixedValue = this.fixNumber(value);
    if (this.layer[propertyName] != fixedValue) {
      // 値変更
      this.changeLayerProperty(fixedValue, propertyName);
    } else {
      // 表示のみ更新
      var input = this.$refs[propertyName] as HTMLInputElement;
      input.value = this[propertyName];
    }
  }

  private increaseNumber(delta: number, propertyName: string): any {
    // 値の補正
    var fixedValue = this.fixNumber(this.layer[propertyName], delta);
    if (this.layer[propertyName] != fixedValue) {
      // 値変更
      this.changeLayerProperty(fixedValue, propertyName);
    }
  }

  //↓↓↓↓↓各値↓↓↓↓↓
  //propsでもらいたい

  private get strokeWidth(): string {
    return this.fixNumber(this.layer.strokeWidth).toFixed(2);
  }

  private get strokeType(): number {
    return this.layer.strokeType;
  }

  private get startType(): number {
    return this.layer.startType;
  }

  private get startWidth(): number {
    return this.layer.startWidth;
  }

  private get endType(): number {
    return this.layer.endType;
  }

  private get endWidth(): number {
    return this.layer.endWidth;
  }

  get strokeColor() : ColorConstruct{
    //この書き方だとなぜか認識されない
    return this.layer.strokeColor;
  }

  get strokeColorStyle(){
        return {
            background : this.strokeColor.hex
        }
    }

  // 色変更中
  private onChangingColor(color)
  {
    this.changeLayerProperty(color, "strokeColor");
  }
    // 色変更完了
  private onChangedColor(color)
  {
    this.changeLayerProperty(color, "strokeColor");
  }

  get opacity() {
    return this.layer.opacity;
  }

  set opacity(opacity) {
    this.changeLayerProperty(opacity, "opacity");
  }

  //↑↑↑↑↑各値↑↑↑↑↑

  private changeLayerProperty(value: any, propertyName: string) {
    this.$emit("doCommand", "changeLayerProperty", {
      layer: this.layer,
      propertyName: propertyName,
      value: value
    });
  }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
